import React, { useMemo, useState, useCallback } from 'react'
import OrderlikeLayout from '../../../../../generic/Layouts/OrderlikeLayout'
import ControlSearchPannelLayout from '../../../../../generic/Layouts/Wrappers/ControlSearchPannelLayout'
import SearchInput from '../../../../../generic/inputs/inputSearch'
import BodyScrollContainer from '../../../../../generic/Layouts/Wrappers/BodyScrollContainer'
import TitlesList from '../../../../../generic/titlesRowItem/TitlesList'
import TeudaWithDetails from './TeudaWithDetails'
import useDataFetcher from '../../knisot/hooks/useFetchData'
import { useProblemStateManager } from '../context/ProblemStateManager'
import DatePickerISO from '../../forcasts/Distribution/Components/DatePickerISO'
import { ITeudotWithDetailsAndProblems, ICreateProblemData, ICreateProblemLine } from '../../../../../modules/API/TeudotProblems/models/problems'
import ColumModal from '../../../../../generic/Layouts/ColumModal'
import ProblemModal from '../Components/ProblemModal'
import { ISelectedProduct } from '../types/problemModal'
import { TEUDOT_PROBLEMS } from '../../../../../modules/API/TeudotProblems/teudotProblems'
import { calcPrevDateRange } from '../helpers/dateUtils'
import { handleNotifications } from '../../../../../generic/utils/handleNotifications'
import { useNavigate } from 'react-router-dom'
import { useProblemTypes } from '../hooks/useProblemTypes'
import FilterIcon from '../../../../../generic/icons/IconLib/FilterIcon'
import FilterProblemMain from '../Components/FilterProblemMain'
import DropdownByIcon from '../../azmanotRehesh/Layouts/DropdownByIcon'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../../store/reducers/rootReducer'
import { IClientsItem } from '../../../../../modules/API/Defaults/models/customers'
import ControlButton from '../../../../../generic/buttons/ControlButton'

const ProblemsTeudotCreate = () => {
  const navigate = useNavigate()
  const customerList: IClientsItem[] = useSelector((state: RootState) => state.defaults?.clientList?.list || [])
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [selectedProduct, setSelectedProduct] = useState<ISelectedProduct | null>(null)
  const [search, setSearch] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { date, daysPast } = useProblemStateManager()
  const [dateToCreate, setDateToCreate] = useState(date[1])
  const [selectedCustomerID, setSelectedCustomerID] = useState<number>(0)
  const [selectedProblemType, setSelectedProblemType] = useState<number>(0)
  const [selectedProblemStatus, setSelectedProblemStatus] = useState<number>(0)
  // Load problem types when component mounts
  const { 
    problemTypes, 
    isLoading: isLoadingProblemTypes 
  } = useProblemTypes()
  
  const formatedString = useMemo(() => {
    return calcPrevDateRange(dateToCreate, daysPast)
  }, [dateToCreate, daysPast]) 
  
  const {
    data: teudotList,
    setData: setTeudotList,
    isLoading: isLoadingTeudot
  } = useDataFetcher<ITeudotWithDetailsAndProblems[]>(
    TEUDOT_PROBLEMS.getDeliveriesWithPalletDetailsAndProblems, 
    `${formatedString}&CustomerID=${selectedCustomerID}`
  )

  const handleControlModal = useCallback(() => {
    setIsOpenModal(!isOpenModal)
  }, [isOpenModal])
  
  const handleSelectProduct = useCallback((item: ISelectedProduct) => {
    handleControlModal()
    setSelectedProduct(item)
  }, [handleControlModal])
  
  const handleBack = useCallback(() => {
    navigate(-1)
  }, [history])
  
  const handleSubmitProblem = useCallback(async (data: { generalRemark: string; problems: Omit<ICreateProblemLine, 'id'>[] }) => {
    if (!selectedProduct || !teudotList) return
    
    setIsSubmitting(true)
    
    try {
      const createData: ICreateProblemData = {
        PalletDetailRecID: selectedProduct.PalletDetailsRecID,
        Remark: data.generalRemark,
        Problems: data.problems
      }

      const res = await TEUDOT_PROBLEMS.createProblem(createData)
      
      const newArray = [...teudotList].map(item => {
        if(item.Delivery_Num === res.Delivery_Num && item.Delivery_Sub === res.Delivery_Sub) {
          return {
            ...item,
            PalletDetails: item.PalletDetails.map(pallet => pallet.RecID === selectedProduct.PalletDetailsRecID ? {
              ...pallet,
              Problems: res.ProblemLines
            } : pallet)
          }
        }
        return item
      })
      setTeudotList(newArray)
      
      
      handleControlModal() 
      // navigate(-1)
      handleNotifications("פניה נוצרה בהצלחה", {type: "success"})
    } catch (error) {
        console.error('Error creating problem:', error)
        handleNotifications("אירעה שגיאה בעת צורת הבעיה", {type: "error"})

    } finally {
      setIsSubmitting(false)
    }
  }, [selectedProduct, handleControlModal, teudotList, setTeudotList])

  const problemList = useMemo(() => {
    if (!teudotList) return []
    const problemSet = new Set()
    teudotList.forEach(problem => {
      problem.PalletDetails?.forEach(pallet => {
        pallet.Problems?.forEach(problem => {
          problemSet.add(problem.ProblemType)
        })
      })
    })

    const defaultProblemList = problemTypes?.filter(type => problemSet.has(type.Code)) || []
    return defaultProblemList
  }, [teudotList, problemTypes])
  
  const render = useMemo(() => {
    if (!teudotList) return []
    return teudotList.filter((item) => {
      return (
        item.Delivery_Num.toString().includes(search.toLowerCase()) ||
        item.SellerDesc?.trim().toLowerCase().includes(search.toLowerCase()) ||
        item.Customer_Name.trim().trim().toLowerCase().includes(search.toLowerCase()) ||
        item.PalletDetails?.some(pallet => 
          (`${pallet.ProductDesc.trim().trim().toLowerCase()} ${pallet.VarietyDesc.trim().trim().toLowerCase()} ${pallet.SizeID.trim().trim().toLowerCase()}`).includes(search.toLowerCase()))
      ) &&
      (selectedCustomerID === 0 || item.CustomerID === selectedCustomerID)
      && (selectedProblemStatus === 0 || item.PalletDetails?.some(pallet => pallet.Problems?.some(problem => problem.Status === selectedProblemStatus)))
    })
  }, [teudotList, search, selectedCustomerID, selectedProblemStatus])


  const additionalItemProps = {
    handleSelectProduct
  }
  
  const additionalModalProps = {
    selectedProduct,
    onSubmit: handleSubmitProblem,
    isLoading: isSubmitting,
    problemTypes,

  }
  
  return (
    <OrderlikeLayout
      label="בחר תעודה"
    >
      {
        isOpenModal && (
          <ColumModal 
            controlFunc={handleControlModal}
            title={`${selectedProduct?.ProductDesc.trim()} ${selectedProduct?.VarietyDesc.trim()} ${selectedProduct?.SizeID.trim()}`}
            childrenProps={additionalModalProps}
            Children={ProblemModal}
          />
        )
      }
      <ControlSearchPannelLayout>
       
        <SearchInput 
          input={search}
          setInput={setSearch}
        />
        <DropdownByIcon
          icon={<FilterIcon />}
          isSelected={selectedCustomerID !== 0}
          isOreintaionRight
        >
           {/* <DatePickerISO
            selected={dateToCreate}
            onChange={setDateToCreate}
            disabled={true}
          /> */}
          <FilterProblemMain
            selectedCustomerID={selectedCustomerID}
            setSelectedCustomerID={setSelectedCustomerID}
            filteredCustomerList={customerList || []}
            selectedProblemType={selectedProblemType}
            setSelectedProblemType={setSelectedProblemType}
            problemList={problemList}
            selectedProblemStatus={selectedProblemStatus}
            setSelectedProblemStatus={setSelectedProblemStatus}
          />
        </DropdownByIcon>
      </ControlSearchPannelLayout>
      <BodyScrollContainer>
        <TitlesList
          list={render}
          uniqueKey={"Delivery_Num"}
          Element={TeudaWithDetails}
          additionalData={additionalItemProps}
        />
      </BodyScrollContainer>
      <ControlButton
        lable={'חזרה'}
        handleClick={handleBack}
      />
    </OrderlikeLayout>
  )
}

export default ProblemsTeudotCreate